export { OtherProducts } from './other-products'
export type { OtherProductItem, OtherProductsProps } from './other-products.model'
